export class RemoveItemFromTemplateError extends Error {
  constructor(
    message: string = 'Failed to remove item from inspection template',
    options?: ErrorOptions
  ) {
    super(message, options);
    this.name = 'RemoveItemFromTemplateError';
  }
}
